import script from "./free-receive.vue?vue&type=script&lang=ts&setup=true"
export * from "./free-receive.vue?vue&type=script&lang=ts&setup=true"

import "./free-receive.vue?vue&type=style&index=0&id=6a1b3c28&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1b3c28"]])

export default __exports__